<template>
  <div class="container-page">
    <p class="title-inner">Экспортный потенциал по услугам</p>
    <div class="mb-16">
      <ButtonComponent
        v-permission="permissions.create"
        class="mr-2"
        mod="gradient-bg"
        buttonType="button"
        :disabled="importInProgress"
        @click="editCard(0)"
      >
        Создать
      </ButtonComponent>
      <ButtonComponent
        v-permission="permissions.import"
        mod="gradient-bg"
        buttonType="button"
        :disabled="importInProgress"
        @click="importExcel()"
      >
        {{ !importInProgress ? 'Загрузить из Excel' : 'Загрузка...' }}
      </ButtonComponent>
    </div>
    <div class="mb-4">
      <DefaultFilter :filterValue="filter" @loadFilter="onLoadFilter" />
    </div>
    <div v-if="isAccessAllowed">
      <div class="table-container mb-16 js-table-arrow">
        <table class="stockTable">
          <thead>
            <tr>
              <th>Коды вида услуги</th>
              <th>Вид услуги</th>
              <th>Потенциал прироста, млн $ США</th>
              <th>Фактический потенциал, $ США</th>
              <th>Страна-экспортер</th>
              <th>Страна-импортер</th>
              <th></th>
              <th></th>
            </tr>
            <tr>
              <th class="filter">
                <FilterInput placeholder="Код" v-model="filter.serviceCode" v-on:valueChangedDebounced="changeFilter" />
              </th>
              <th class="filter">
                <FilterInput
                  placeholder="Вид услуги"
                  v-model="filter.serviceName"
                  v-on:valueChangedDebounced="changeFilter"
                />
              </th>
              <th class="filter">
                <FilterInput
                  placeholder="От"
                  v-model="filter.valueFrom"
                  type="number"
                  v-on:valueChangedDebounced="changeFilter"
                />
                <FilterInput
                  placeholder="До"
                  v-model="filter.valueTo"
                  type="number"
                  v-on:valueChangedDebounced="changeFilter"
                />
              </th>
              <th class="filter">
                <FilterInput
                  placeholder="От"
                  v-model="filter.exportValueFrom"
                  type="number"
                  v-on:valueChangedDebounced="changeFilter"
                />
                <FilterInput
                  placeholder="До"
                  v-model="filter.exportValueTo"
                  type="number"
                  v-on:valueChangedDebounced="changeFilter"
                />
              </th>
              <th class="filter">
                <FilterInput
                  :select2Options="countryList"
                  placeholder="Выберите"
                  type="select2"
                  v-model="filter.fromCountryId"
                  :select2Settings="select2Settings"
                  v-on:valueChangedDebounced="changeFilter"
                />
              </th>
              <th class="filter">
                <FilterInput
                  :select2Options="countryList"
                  placeholder="Выберите"
                  type="select2"
                  v-model="filter.toCountryId"
                  :select2Settings="select2Settings"
                  v-on:valueChangedDebounced="changeFilter"
                />
              </th>
              <th class="filter"></th>
              <th class="filter"></th>
            </tr>
          </thead>
          <tbody v-if="page.items?.length && !isLoading">
            <tr v-for="item in page.items" :key="item.id">
              <td>{{ item.serviceCode }}</td>
              <td>{{ item.serviceName }}</td>
              <td>{{ item.value }}</td>
              <td>{{ item.exportValue }}</td>
              <td>{{ item.fromCountry?.name }}</td>
              <td>{{ item.toCountry?.name }}</td>
              <td>
                <IconComponent
                  v-permission="permissions.edit"
                  :disabled="importInProgress"
                  @click="editCard(item.id)"
                  name="mode"
                />
              </td>
              <td>
                <IconComponent
                  v-permission="permissions.delete"
                  :disabled="importInProgress"
                  @click="deleteCard(item.id)"
                  name="delete"
                />
              </td>
            </tr>
          </tbody>
          <tbody v-else-if="isLoading">
            <tr>
              <td class="text-center" colspan="5">Загрузка...</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td class="text-center" colspan="5">Нет данных.</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="page.pagesTotal > 1">
        <Pagination
          :pageCount="page.pagesTotal"
          :currentPage="page.pageNumber"
          @change="onPageChange($event, false)"
          @more="onPageChange($event, true)"
        />
      </div>
    </div>
    <section>
      <ModalComponent v-model="importModal" title="Импорт файла" @close="closeModal">
        <ImportModal @doimport="doImport" @close="closeModal" />
      </ModalComponent>
    </section>
  </div>
</template>

<script>
  import DefaultFilter from '@/common/components/DefaultFilter.vue';
  import FilterInput from '@/common/components/FilterInput.vue';
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import Constants from '@/common/constants';
  import security from '@/common/mixins/security';
  import Utils from '@/common/utils';
  import { loadFilter, saveFilter } from '@/common/utils/filterManager';

  import ImportModal from '@/components/modals/ImportModal.vue';

  import ServiceApi from '@/modules/importanalytics/api/exportPotentialService';

  import IconComponent from '../../../common/ui/IconComponent.vue';
  import ModalComponent from '../../../components/modals/ModalComponent.vue';
  import Api from '../api/index';

  const PERMISSIONS = {
    view: Constants.Permissions.ExportPotentialServicesView,
    import: Constants.Permissions.ExportPotentialServicesImport,
    create: Constants.Permissions.ExportPotentialServicesCreate,
    edit: Constants.Permissions.ExportPotentialServicesEdit,
    delete: Constants.Permissions.ExportPotentialServicesDelete,
  };

  export default {
    name: 'ExportPotentialService',
    components: { ImportModal, ModalComponent, ButtonComponent, FilterInput, DefaultFilter, IconComponent },
    mixins: [security],
    data() {
      return {
        route: 'exportpotentialserviceitem',
        page: {},
        request: {
          pageNumber: 1,
          pageSize: Constants.pageSize,
        },
        importInProgress: false,
        importModal: false,
        isLoading: false,

        select2Settings: Constants.select2Settings,
        countryList: [],
        filter: {
          serviceCode: '',
          serviceName: '',
          toCountryId: null,
          fromCountryId: null,
          valueFrom: null,
          valueTo: null,
          exportValueFrom: null,
          exportValueTo: null,
        },
      };
    },
    computed: {
      permissions: () => PERMISSIONS,
    },
    created() {
      this.checkPermissionAndRedirect(PERMISSIONS.view).then((isAllowed) => {
        if (!isAllowed) return;

        loadFilter(this.$options.name).then((response) => {
          let filter = response;
          if (filter) {
            this.filter = filter;
          }
          this.loadDictionaries();
          this.loadPage();
        });
      });
    },
    methods: {
      loadDictionaries() {
        Utils.loadSelectOptions('countryList', this.countryList, true);
      },
      loadPage(append) {
        this.isLoading = !append;
        var params = Object.assign(this.filter, this.request);
        Api.search(this.route, params)
          .then((response) => {
            if (!append) {
              this.page = {};
              this.$nextTick(() => {
                this.page = response.data;
              });
            } else if (response.data) {
              this.page.pageNumber = response.data.pageNumber;
              this.page.items = this.page.items.concat(response.data.items);
            }
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      },
      importExcel() {
        this.importModal = true;
      },
      doImport(file) {
        this.closeModal();
        this.importInProgress = true;
        Api.downloadFile(this.route, file)
          .then(() => {
            Constants.alert.fire('Импорт', 'Импорт успешно выполнен.', 'success');
            this.loadPage();
            this.importInProgress = false;
          })
          .catch((error) => {
            console.log(error?.response?.data);
            Constants.alert.fire('Импорт', 'Ошибка при импорте данных.', 'error');
            this.importInProgress = false;
          });
      },
      onPageChange(pageNumber, addToExist) {
        this.request.pageNumber = pageNumber;
        this.loadPage(addToExist);
      },
      closeModal() {
        this.importModal = false;
      },
      changeFilter() {
        this.request.pageNumber = 1;
        saveFilter(this.$options.name, this.filter);
        this.loadPage(false);
      },
      onLoadFilter(item) {
        this.filter = item;
        this.changeFilter();
      },
      editCard(id) {
        this.$router.push({ name: 'ExportPotentialServiceCard', params: { id: id, action: 'edit' } });
      },
      deleteCard(id) {
        Constants.alert.fire(Constants.confirmOptions.delete).then((res) => {
          if (res.isConfirmed) {
            ServiceApi.delete(id)
              .then(() => {
                Constants.alert.fire('Удаление', 'Запись удалена', 'success');
                this.loadPage();
              })
              .catch((error) => {
                Constants.alert.fire(
                  'Удаление',
                  error.response && error.response.data ? error.response.data : 'Запись не удалена',
                  'error',
                );
              });
          }
        });
      },
    },
  };
</script>
